const styles = {
  btn: "text-sm md:text-base fixed p-3 bottom-12 right-8 bg-thirdGreen  rounded-full duration-700",
  onShowBtn: "opacity-100 cursor-pointer",
  onHideBtn: "opacity-0 cursor-default",
  arrowIcon: "text-white w-6 h-6",
};
export default styles;
